import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { palette } from '@awarego-ui/components';

const Nav = styled.nav`
    display: flex;
    gap: 16px;
    margin: 8px 0 18px;
    border-bottom: 1px solid ${palette.graphite.silver};
    padding-bottom: 8px;
    flex-wrap: wrap;
`;

const Item = styled(Link)`
    font-size: 13px;
    font-weight: ${(p) => (p.$active ? 700 : 500)};
    color: ${(p) =>
        p.$active ? palette.evergreen.aspargus : palette.graphite.charcoal};
    text-decoration: none;
    border-bottom: 2px solid
        ${(p) => (p.$active ? palette.evergreen.aspargus : 'transparent')};
    padding-bottom: 6px;
`;

export default function AwarePhishSubNav({ active }) {
    return (
        <Nav>
            <Item to="/aware-phish" $active={active === 'overview'}>
                Overview
            </Item>
            <Item to="/aware-phish/campaigns" $active={active === 'campaigns'}>
                Simulations
            </Item>
            <Item to="/aware-phish/templates" $active={active === 'templates'}>
                Templates
            </Item>
            <Item to="/aware-phish/delivery" $active={active === 'delivery'}>
                Delivery
            </Item>
        </Nav>
    );
}
